<template>
  <div>
    <v-row justify="center">
      <v-dialog max-width="600px" persistent v-model="dialogCapturaFotoForm">
        <v-card>
          <v-toolbar color="grey lighten-4" flat dark>
            <v-toolbar-title class="text-h6 grey--text">Capturar Foto</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <div class="row">
              <v-col cols="12" v-show="!avatar && !canvas">
                <video ref="video" autoplay v-show="camera" width="100%"></video>
                <v-row>
                  <v-col cols="4">
                    <v-btn
                      depressed
                      small
                      class="primary"
                      dark
                      @click="play"
                      block
                      v-if="controls.play"
                    >
                      <v-icon>mdi-play</v-icon>
                    </v-btn>
                    <v-btn
                      depressed
                      small
                      class="orange"
                      dark
                      @click="pause"
                      block
                      v-if="controls.pause"
                    >
                      <v-icon>mdi-pause</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      depressed
                      small
                      class="indigo"
                      dark
                      @click="changeCamera"
                      block
                      v-if="controls.pause"
                    >
                      <v-icon>mdi-camera-flip-outline</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      depressed
                      small
                      class="teal"
                      dark
                      @click="screenshot"
                      block
                      v-if="controls.stop"
                    >
                      <v-icon>mdi-camera-iris</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="avatar">
                <v-row>
                  <v-col cols="12">
                    <Cropper
                      ref="cropper"
                      class="cropper"
                      :src="avatar"
                      :stencil-props="{
                        aspectRatio: 3 / 4,
                      }"
                    ></Cropper>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-btn depressed color="teal" block dark @click="cropImage" small>
                      <v-icon left>mdi-crop</v-icon>
                      Cortar
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn depressed color="red" @click="clearImage" block dark small>
                      <v-icon color="white" left>mdi-trash-can</v-icon>
                      Remover
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-show="canvas">
                <div>
                  <v-row align="center">
                    <v-col cols="12">
                      <v-responsive>
                        <v-img :src="imgUrl" :aspect-ratio="3 / 4" contain></v-img>
                      </v-responsive>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-btn color="primary" depressed block dark small @click="uploadImage">
                        <v-icon left>mdi-content-save</v-icon>
                        Salvar
                      </v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn color="red" @click="removeImageCanvas" block depressed dark small>
                        <v-icon left color="white">mdi-trash-can</v-icon>
                        Remover
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </div>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn @click="toggleCapturaFotoForm" color="red" dark depressed>
              <v-icon left small>mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <canvas ref="canvas" v-show="false"></canvas>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import { mapActions, mapState } from 'vuex';
import toastMessage from '@/services/util/alertService';

export default {
  name: 'ModalCapturaFotoForm',
  components: { Cropper },
  data: () => ({
    useFrontCamera: true,
    videoStream: undefined,
    camera: false,
    imageCroped: undefined,
    avatar: undefined,
    canvas: undefined,
    imgUrl: undefined,
    controls: {
      init: true,
      play: false,
      pause: false,
      stop: false,
    },
    constraints: {
      audio: false,
      video: {
        width: {
          min: 1280,
          ideal: 1920,
          max: 2560,
        },
        height: {
          min: 720,
          ideal: 1080,
          max: 1440,
        },
      },
    },
  }),
  created() {
    this.checkIsCamera();
  },
  computed: {
    ...mapState('pessoa', ['dialogCapturaFotoForm', 'data']),
  },
  methods: {
    ...mapActions('pessoa', ['toggleCapturaFotoForm', 'updateFoto']),
    checkIsCamera() {
      if (!('mediaDevices' in navigator) || !('getUserMedia' in navigator.mediaDevices)) {
        toastMessage.errorDestroy('Browser não compatível com leitura de câmera.');
        return null;
      }
      return true;
    },
    initCamera() {
      this.initializeCamera();
      this.camera = true;
      this.controls.init = false;
      this.controls.play = false;
    },
    play() {
      this.$refs.video.play();
      this.controls.play = false;
      this.controls.pause = true;
    },
    pause() {
      this.controls.play = true;
      this.controls.pause = false;
      this.$refs.video.pause();
    },
    screenshot() {
      this.$refs.canvas.width = this.$refs.video.videoWidth;
      this.$refs.canvas.height = this.$refs.video.videoHeight;
      this.$refs.canvas.getContext('2d').drawImage(this.$refs.video, 0, 0);
      this.avatar = this.$refs.canvas.toDataURL('image/png');
    },
    changeCamera() {
      this.useFrontCamera = !this.useFrontCamera;
      this.initializeCamera();
    },
    stopVideoStream() {
      const { stream } = window;
      if (stream) {
        const tracks = stream.getTracks();
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < tracks.length; i++) {
          const track = tracks[i];
          track.stop();
        }
        window.stream = null;
        this.controls.init = true;
        this.controls.play = false;
        this.controls.pause = false;
        this.controls.stop = false;
        this.camera = false;
        this.videoStream = undefined;
      }
    },
    async initializeCamera() {
      this.stopVideoStream();
      this.constraints.video.facingMode = this.useFrontCamera ? 'user' : 'environment';

      try {
        this.videoStream = await navigator.mediaDevices.getUserMedia(this.constraints);
        window.stream = this.videoStream;
        this.$refs.video.srcObject = this.videoStream;
        this.controls.init = false;
        this.controls.play = false;
        this.controls.pause = true;
        this.controls.stop = true;
        this.camera = true;
      } catch (err) {
        // alert("Could not access the camera");
      }
    },
    stopClear() {
      this.stopVideoStream();
      this.clearImage();
    },
    stop() {
      this.stopVideoStream();
    },
    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();
      this.canvas = canvas;
      this.stop();
      this.cropedImage();
    },
    cropedImage() {
      this.imgUrl = this.canvas.toDataURL('image/jpeg');
      this.avatar = undefined;
    },
    clearImage() {
      this.avatar = undefined;
      this.canvas = undefined;
      this.imgUrl = undefined;
      this.controls.init = true;
    },
    removeImageCanvas() {
      this.clearImage();
      this.initCamera();
    },
    uploadImage() {
      if (this.canvas) {
        const form = new FormData();
        this.canvas.toBlob((blob) => {
          form.append('foto', blob);
          form.append('cgm_id', this.data.id);
          this.updateFoto(form)
            .then(() => {
              toastMessage.successSave('Upload efetuado com sucesso.');
              this.toggleCapturaFotoForm();
            })
            .catch(() => toastMessage.errorSave('Erro ao enviar foto.'));
        }, 'image/jpeg');
      }
    },
  },
  watch: {
    dialogCapturaFotoForm(value) {
      if (value) {
        this.initCamera();
      } else {
        this.stopClear();
      }
    },
  },
};
</script>
